import Nav from "../components/Nav";
import Footer from "../components/Footer";
import { TeamMember } from "../components/studio/TeamMember";
import { StudioIntro, StudioServices, StudioSectors } from "../components/studio/StudioSections";
import { LEADERSHIP } from "../mock";
import { Seo } from "../components/Seo";

export default function Studio() {
  return (
    <div className="mp-paper min-h-screen flex flex-col" data-testid="studio-page">
      <Seo page="studio" />
      <Nav theme="light" />
      <main className="flex-1 max-w-[1600px] w-full mx-auto px-6 md:px-10 pt-10 md:pt-16">
        <h1 className="font-display font-light text-[34px] md:text-[42px] leading-[0.95] tracking-tight mp-fade">Studio</h1>
        <StudioIntro />

        <div className="mt-24 md:mt-32 flex items-baseline justify-between border-t border-[rgba(35,33,28,0.14)] pt-8">
          <h2 className="font-display text-[26px] md:text-[36px] tracking-tight">Team</h2>
          <span className="font-label text-[10px] text-[#8b8578]">Leadership</span>
        </div>
        <div className="mt-14 md:mt-20 space-y-20 md:space-y-28" data-testid="studio-team">
          {LEADERSHIP.map((p, i) => (
            <TeamMember key={p.name} person={p} flipped={i % 2 === 1} />
          ))}
        </div>

        <StudioServices />
        <StudioSectors />
      </main>
      <Footer theme="light" />
    </div>
  );
}
